import OnboardingView from './OnboardingView';
import './OnboardingView.scss';

export default OnboardingView;
